//  React TS Base Styles
import colors from '../../base/colors'

const { transparent } = colors

// types
type Types = any

const textField: Types = {
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,
    },
  },
}

export default textField
